export const SALESFORCE_ID_LENGTH = 18;

const SALESFORCE_ID_PATTERN = new RegExp(`^[A-Za-z0-9]{${SALESFORCE_ID_LENGTH}}$`);

export const isValidSalesforceId = (id: string): boolean => SALESFORCE_ID_PATTERN.test(id);

export const getInvalidSalesforceIds = (ids: string[]): string[] =>
  ids.filter(id => !isValidSalesforceId(id));

// Mirrors bpm-lambdas lib/slackChannel.ts: client channels are stored as "#channel-name" (lowercase
// letters, digits, hyphens and underscores, up to 80 characters); a missing "#" is added and blank
// means none.
const SLACK_CHANNEL_PATTERN = /^#[a-z0-9][a-z0-9_-]{0,79}$/;

export const normalizeSlackChannel = (raw: string): string => {
  const trimmed = raw.trim();
  if (!trimmed) {
    return '';
  }
  return trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
};

export const isValidSlackChannel = (raw: string): boolean => {
  const channel = normalizeSlackChannel(raw);
  return channel === '' || SLACK_CHANNEL_PATTERN.test(channel);
};
